import React, { ReactNode } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

type Props = {
  children: ReactNode
  footer?: ReactNode
  header?: ReactNode
  width?: string
}

export const SidepanelWrapper = ({ children, footer, header, width = '404px' }: Props) => {
  return (
    <Box
      className="absolute right-2 z-50"
      role="dialog"
      aria-label="Node configuration"
      style={{
        top: '16px',
        maxHeight: 'calc(100% - 80px)',
        width,
      }}
      background="white"
      border={{ all: { width: 's1', color: 'grey300', style: 'solid' } }}
      borderRadius={{ all: 'abs012' }}
      flexDirection="column"
      boxShadow="s100"
    >
      {header && (
        <Box paddingY="s20" paddingX="s16" borderRadius={{ topLeft: 'abs012', topRight: 'abs012' }}>
          {header}
        </Box>
      )}
      <Box
        style={{ overflowY: 'auto' }}
        paddingY="s20"
        paddingX="s16"
        gap="s16"
        flexGrow
        borderRadius={header ? undefined : { topLeft: 'abs012', topRight: 'abs012' }}
      >
        {children}
      </Box>
      {footer && (
        <Box
          style={{
            borderTop: '1px solid #E5E7EB',
          }}
          padding="s16"
          borderRadius={{ bottomLeft: 'abs012', bottomRight: 'abs012' }}
        >
          {footer}
        </Box>
      )}
    </Box>
  )
}
